export const USER = "/api/user";
export const AUTH = "/api/auth";
export const PARTNER = "/api/partner";
export const INVOICE_DATA = "/api/partner/invoice";
export const ANNOUNCEMENT = "/api/announcement";
export const PARTNER_ANNOUNCEMENTS = "/api/announcement/my-ads";
export const PARTNER_ANNOUNCEMENT_COUNTS = "/api/announcement/my-ads-count";
export const PARTNER_ANNOUNCEMENTS_COUNT_PER_PHONE_NUMBER =
  "/api/announcement/my-ads-count/phone";
export const ANNOUNCEMENT_PROMOTION = "/api/announcement/promotion";
export const ANNOUNCEMENTS = "/api/announcement/fetch-all";
export const PAYMENT = "/api/payment/create-session";
export const SUPPLIES = "/api/supply";
export const EDUCATION = "/api/education";
export const DISCOUNT_CODE = "/api/discount-code";
export const CHANGE_EMAIL_REQUEST =
  "/api/auth/change-email/send-current-confirmation";
export const CONFIRM_EMAIL_CHANGE_CURRENT =
  "/api/auth/change-email/confirm-current";
export const CONFIRM_EMAIL_CHANGE_NEW = "/api/auth/change-email/confirm-new";
export const GET_PRICE_FOR_COUNTRY = "/api/payment/price-for-country";
export const GET_MOST_POPULAR_AND_LATEST = ANNOUNCEMENT + "/popular-and-latest";
export const GET_PLACE_NAME = "/api/place";

export const UPDATE_ANNOUNCEMENT = (id: string) => `/api/announcement/${id}`;
export const ANNOUNCEMENT_DETAILS = (id: string) => `/api/announcement/${id}`;
export const DELETE_ANNOUNCEMENT = (id: string) => `/api/announcement/${id}`;
export const CHANGE_ANNOUNCEMENT_HIDDEN_STATUS = (id: string) =>
  `/api/announcement/${id}/hidden-status`;
